export const HELP_LINKS = {
    youtube: 'https://youtu.be/_dTp5tHiSvQ?si=QBD0sHtjD7WMJGjq',
    community: 'https://chat.whatsapp.com/KSI0aQplUyT5BFC1XzGQVj?s=cl&p=i&mlu=4&ilr=4&iam=2',
    support:
        'https://wa.me/558587069521?text=Ol%C3%A1%2C%20estou%20vindo%20do%20Financeiro%20Di%C3%A1rio%20e%20gostaria%20de%20ajuda',
} as const;
